<template>
  <div class="padbox">
    <el-row :gutter="60">
      <el-col :span="12">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-divider content-position="left">达人码锁定时长</el-divider>
            <el-form
              ref="hourTimeForm"
              :model="rulesForm"
              :rules="rules"
              class="demo-editForm"
              label-width="200px"
            >
              <el-form-item label="锁定时长(分):" prop="hourTime">
                <el-input
                  v-model="rulesForm.hourTime"
                  type="number"
                  min="0"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="submitForm('hourTimeForm')"
                  style="margin-left: 33%"
                  >提交</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-divider content-position="left">小程序分享图</el-divider>
            <el-form
              ref="shareForm"
              :model="rulesForm"
              :rules="rules"
              class="demo-editForm"
              label-width="100px"
            >
              <el-form-item label="分享图:" prop="sharePoints">
                <VploadImgFour
                  :fileData="fileData"
                  :fileSize="fileSize"
                  :fileType="fileType"
                  :limit="1"
                  :value="rulesForm.shareUrl"
                  @input="getImg"
                >
                </VploadImgFour>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="submitForm('shareForm')"
                  style="margin-bottom: 20px; float: left"
                  >提交</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import VploadImgFour from "../inc/VploadImgFour";
export default {
  name: "configuration",
  components: { VploadImgFour },
  data() {
    return {
      fileData: {
        type: 0,
        fileType: 0,
      },
      fileType: ["png", "jpg", "jpeg"],
      fileSize: 5,
      dialogVisible: false,
      rulesForm: {
        hourTime: "",
        shareUrl: [],
      },
      rules: {},
    };
  },
  created() {
    this.getHourTime();
    this.getShareImage();
  },
  methods: {
    getImg(val) {
      this.rulesForm.shareUrl = val;
    },
    getHourTime() {
      this.$axios.get("/admin/sysConfig/getHourTime", {}).then((res) => {
        this.rulesForm.hourTime = res.data;
      });
    },
    getShareImage() {
      this.$axios.get("/admin/sysConfig/getShareUrl", {}).then((res) => {
        this.rulesForm.shareUrl = res.msg;
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName == "hourTimeForm") {
            if (
              this.rulesForm.hourTime === "" ||
              this.rulesForm.hourTime === null ||
              this.rulesForm.hourTime === undefined ||
              this.rulesForm.hourTime < 0
            ) {
              this.$message({
                message: "锁定时长不能小于0",
                type: "danger",
              });
              return false;
            }

            var obj = {
              hourTime: this.rulesForm.hourTime,
            };
            this.$axios
              .get("/admin/sysConfig/updHourTime", { params: obj })
              .then((res) => {
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success",
                });
              });
          } else if (formName == "shareForm") {
            var obj = {
              shareUrl: this.rulesForm.shareUrl,
            };
            this.$axios
              .get("/admin/sysConfig/updShareUrl", { params: obj })
              .then((res) => {
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success",
                });
              });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.padbox {
  background: #fff;
  width: 100%;
  height: calc(100% - 120px);
  padding: 20px;
}
</style>
